import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const Andorra: Country = {
    identifier: "Andorra",
    name: "Andorra",
    countryCode: "AD",
    group: CountryGroup.EUROPE,
    isUNMember: true,
    flag: "🇦🇩",
    svgPath: "m 479.68275,331.6274 -0.077,0.025 -0.258,0.155 -0.147,0.054 -0.134,0.027 -0.105,-0.011 -0.058,-0.091 0.006,-0.139 -0.024,-0.124 -0.02,-0.067 0.038,-0.181 0.086,-0.097 0.119,-0.08 0.188,0.029 0.398,0.116 0.083,0.109 10e-4,0.072 -0.073,0.119 z",
}
